import contractsDefaultFilters from "components/Filters/Contracts/contracts-default-filters";
import { FilterProps } from "../filter-definition";
import { RadioButtonDateFilter } from "../GenericFilters/RadioButtonDateFilter";

export const ContractDateFilter = (props: FilterProps) => (
  <RadioButtonDateFilter
    {...props}
    filterKey="contractDate"
    name="Contract Date"
    defaultFilterType={contractsDefaultFilters.contractDateType}
    defaultStartDate={contractsDefaultFilters.contractDateStartDate}
    defaultEndDate={contractsDefaultFilters.contractDateEndDate}
  />
);
